import { SourceName } from 'features/application/hooks/useApplicationTrackErrorEvents';
import useUpdateApplication from 'features/application/hooks/useUpdateApplication';
import Citizenship from 'features/application/screens/Citizenship/Citizenship';
import useReactivationPrefillData from 'features/reactivation/hooks/useReactivationPrefillData';
import { default as React } from 'react';

const CitizenshipWrapper = () => {
  const {
    prefillDataFetching,
    prefillDataError,
    refetch: refetchPrefillData,
    reactivationApplicationId,
  } = useReactivationPrefillData();

  const {
    updateApplication,
    updateApplicationResult,
    isUpdateApplicationLoading,
    isUpdateApplicationSuccess,
  } = useUpdateApplication({
    applicationId: reactivationApplicationId,
    sourceName: SourceName.REACTIVATION_CITIZENSHIP,
  });

  return (
    <Citizenship
      updateApplication={updateApplication}
      fetching={prefillDataFetching}
      error={prefillDataError as Error}
      isReapplication={false}
      hasApplicationLoaded={!!reactivationApplicationId}
      nextRoute="/reactivation/review-info"
      backRoute="/reactivation/review-info"
      isUpdateApplicationLoading={isUpdateApplicationLoading}
      reExecuteQuery={refetchPrefillData}
      updateApplicationResult={updateApplicationResult}
      isUpdateApplicationSuccess={isUpdateApplicationSuccess}
      isReactivation
    />
  );
};

export default CitizenshipWrapper;
